import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import {
  DxButtonGroupModule,
  DxButtonModule,
  DxDraggableModule,
  DxFormModule,
  DxLoadIndicatorModule,
  DxPopoverModule,
  DxSelectBoxModule,
  DxSortableModule,
  DxSplitterModule,
  DxSwitchModule,
  DxTabPanelModule,
  DxTabsModule,
  DxTextAreaModule,
  DxTextBoxModule
} from "devextreme-angular";
import { ButtonModule } from "src/app/components/ui/button/button.module";
import { DirectivesModule } from "../../directives/directives.module";
import { ReportItemConfigAsGridValuePipe } from "./report-designer/pipes/report-item-config-as-grid-value.pipe";
import { ReportItemConfigAsGridPipe } from "./report-designer/pipes/report-item-config-as-grid.pipe";
import { ReportItemConfigAsHeaderValuePipe } from "./report-designer/pipes/report-item-config-as-header-value.pipe";
import { ReportItemConfigAsImageValuePipe } from "./report-designer/pipes/report-item-config-as-image-value.pipe";
import { ReportItemConfigAsSignatureValuePipe } from "./report-designer/pipes/report-item-config-as-signature-value.pipe";
import { ReportItemConfigAsSignaturePipe } from "./report-designer/pipes/report-item-config-as-signature.pipe";
import { ReportItemConfigAsSelectboxPipe } from "./report-designer/pipes/report-item-config-as-selectbox.pipe";
import { ReportItemConfigAsSelectboxValuePipe } from "./report-designer/pipes/report-item-config-as-selectbox-value.pipe";
import { ReportItemConfigAsSpacerPipe } from "./report-designer/pipes/report-item-config-as-spacer.pipe";
import { ReportItemConfigAsTextValuePipe } from "./report-designer/pipes/report-item-config-as-text-value.pipe";
import { ReportItemConfigAsTextPipe } from "./report-designer/pipes/report-item-config-as-text.pipe";
import { ReportItemConfigAsTitleValuePipe } from "./report-designer/pipes/report-item-config-as-title-value.pipe";
import { ReportItemConfigAsTitlePipe } from "./report-designer/pipes/report-item-config-as-title.pipe";
import { ReportItemFormPropertyBindPipe } from "./report-designer/pipes/report-item-form-property-bind.pipe";
import { ReportDesignerCustomComponent } from "./report-designer/report-designer-custom/report-designer-custom.component";
import { ReportDesignerImageComponent } from "./report-designer/report-designer-image/report-designer-image.component";
import { ReportDesignerSignatureComponent } from "./report-designer/report-designer-signature/report-designer-signature.component";
import { ReportDesignerSpacerComponent } from "./report-designer/report-designer-spacer/report-designer-spacer.component";
import { ReportDesignerTabComponent } from "./report-designer/report-designer-tab/report-designer-tab.component";
import { ReportDesignerTableComponent } from "./report-designer/report-designer-table/report-designer-table.component";
import { ReportDesignerTextComponent } from "./report-designer/report-designer-text/report-designer-text.component";
import { ReportDesignerTitleComponent } from "./report-designer/report-designer-title/report-designer-title.component";
import { ReportDesignerComponent } from "./report-designer/report-designer.component";
import { ReportFormRendererSpacerComponent } from "./report-form-renderer/report-form-render-spacer/report-form-renderer-spacer.component";
import { ReportFormRendererCustomComponent } from "./report-form-renderer/report-form-renderer-custom/report-form-renderer-custom.component";
import { ReportFormRendererGridComponent } from "./report-form-renderer/report-form-renderer-grid/report-form-renderer-grid.component";
import { ReportFormRendererImageComponent } from "./report-form-renderer/report-form-renderer-image/report-form-renderer-image.component";
import { ReportFormRendererSignatureComponent } from "./report-form-renderer/report-form-renderer-signature/report-form-renderer-signature.component";
import { ReportFormRendererTabComponent } from "./report-form-renderer/report-form-renderer-tab/report-form-renderer.tab.component";
import { ReportFormRendererTextComponent } from "./report-form-renderer/report-form-renderer-text/report-form-renderer-text.component";
import { ReportFormRendererTitleComponent } from "./report-form-renderer/report-form-renderer-title/report-form-renderer-title.component";
import { ReportFormRendererComponent } from "./report-form-renderer/report-form-renderer.component";
import { ReportDesignerDocumentPreviewComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-document-preview/report-designer-document-preview.component";
import { ReportDesignerPreviewComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-preview/report-designer-preview.component";
import { ReportDesignerTagsComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-tags/report-designer-tags.component";
import { ReportFormRendererTagsComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer-tags/report-form-renderer-tags.component";
import { ReportPreviewComponent } from "src/app/modules/bootstrap/modules/report/report-preview/report-preview.component";
import { ContainerModule } from "src/app/components/ui/container/container-module";
import { AttachmentsModule } from "src/app/components/ui/attachments/attachments.module";
import { ReportDesignerChecklistComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-checklist/report-designer-checklist.component";
import { ReportDesignerCheckComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-check/report-designer-check.component";
import { ReportDesignerEmptyComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-empty/report-designer-empty.component";
import { ReportDesignerSelectboxComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-selectbox/report-designer-selectbox.component";
import { ReportDesignerTextareaComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-textarea/report-designer-textarea.component";
import { ReportFormRendererCheckComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer-check/report-form-renderer-check.component";
import { ReportFormRendererEmptyComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer-empty/report-form-renderer-empty.component";
import { ReportFormRendererChecklistComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer-checklist/report-form-renderer-checklist.component";
import { ReportFormRendererSelectboxComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer-selectbox/report-form-renderer-selectbox.component";
import { ReportFormRendererTextareaComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer-textarea/report-form-renderer-textarea.component";
import { PipesModule } from "src/app/pipes/pipes.module";
import { WysiwygEditorModule } from "src/app/components/ui/wysiwyg-editor/wysiwyg-editor.module";
import { ReportDesignerGroupHorizontalComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-group-horizontal/report-designer-group-horizontal.component";
import { ReportDesignerGroupVerticalComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-group-vertical/report-designer-group-vertical.component";
import { EditableModule } from "src/app/components/ui/editable/editable.module";
import { ReportFormRendererGroupVerticalComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer-group-vertical/report-form-renderer-group-vertical.component";
import { ReportFormRendererGroupHorizontalComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer-group-horizontal/report-form-renderer-group-horizontal.component";
import { ReportDesignerCustomerSignatureComponent } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-customer-signature/report-designer-customer-signature.component";
import { ReportFormRendererCustomerSignatureComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer-customer-signature/report-form-renderer-customer-signature.component";
import { TagModule } from "src/app/components/ui/tag/tag.module";

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,

    DxButtonGroupModule,
    DxButtonModule,
    DxDraggableModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxTextBoxModule,
    DxTextAreaModule,
    DxSelectBoxModule,
    DxSortableModule,
    DxSplitterModule,
    DxTabsModule,
    DxTabPanelModule,
    DxPopoverModule,
    DxSwitchModule,

    TagModule,
    ButtonModule,
    DirectivesModule,
    ContainerModule,
    AttachmentsModule,
    PipesModule,
    WysiwygEditorModule,
    EditableModule
  ],
  declarations: [
    ReportDesignerComponent,
    ReportDesignerTextComponent,
    ReportDesignerTableComponent,
    ReportDesignerSignatureComponent,
    ReportDesignerCustomerSignatureComponent,
    ReportDesignerSpacerComponent,
    ReportDesignerTitleComponent,
    ReportDesignerGroupHorizontalComponent,
    ReportDesignerGroupVerticalComponent,
    ReportDesignerImageComponent,
    ReportDesignerTabComponent,
    ReportDesignerCustomComponent,
    ReportDesignerDocumentPreviewComponent,
    ReportDesignerPreviewComponent,
    ReportDesignerTagsComponent,
    ReportDesignerChecklistComponent,
    ReportDesignerCheckComponent,
    ReportDesignerEmptyComponent,
    ReportDesignerSelectboxComponent,
    ReportDesignerTextareaComponent,

    ReportFormRendererComponent,
    ReportFormRendererTextComponent,
    ReportFormRendererGridComponent,
    ReportFormRendererSignatureComponent,
    ReportFormRendererCustomerSignatureComponent,
    ReportFormRendererSpacerComponent,
    ReportFormRendererTitleComponent,
    ReportFormRendererGroupVerticalComponent,
    ReportFormRendererGroupHorizontalComponent,
    ReportFormRendererImageComponent,
    ReportFormRendererTabComponent,
    ReportFormRendererCustomComponent,
    ReportFormRendererTagsComponent,
    ReportFormRendererCheckComponent,
    ReportFormRendererEmptyComponent,
    ReportFormRendererChecklistComponent,
    ReportFormRendererSelectboxComponent,
    ReportFormRendererTextareaComponent,

    ReportItemConfigAsHeaderValuePipe,
    ReportItemConfigAsSignaturePipe,
    ReportItemConfigAsSignatureValuePipe,
    ReportItemConfigAsTextPipe,
    ReportItemConfigAsTextValuePipe,
    ReportItemConfigAsGridPipe,
    ReportItemConfigAsGridValuePipe,
    ReportItemConfigAsSelectboxPipe,
    ReportItemConfigAsSelectboxValuePipe,
    ReportItemConfigAsTitlePipe,
    ReportItemConfigAsTitleValuePipe,
    ReportItemConfigAsSpacerPipe,
    ReportItemFormPropertyBindPipe,
    ReportItemConfigAsImageValuePipe,

    ReportPreviewComponent
  ],
  exports: [
    ReportDesignerComponent,
    ReportFormRendererComponent,
    ReportPreviewComponent
  ]
})
export class ReportModule {}
